import releasePageIds from "../Releases/ReleasesRoutes/releasePageIds";
import { pageId } from "utils/pageId";
import runbookSnapshotPageIds from "../Runbooks/RunbookSnapshots/runbookSnapshotPageIds";

export default () => ({
    projects: {
        root: pageId("Projects"),
    },
    project: () => {
        return {
            root: pageId("Project"),
            ...releasePageIds(),
            overview: pageId("Project.Overview", "Overview"),
            tasks: pageId("Project.Tasks", "Tasks"),
            settings: {
                root: pageId("Project.Settings", "Settings"),
                versionControl: pageId("Project.VersionControlSettings", "Version Control Settings"),
            },
            channels: pageId("Project.Channels", "Channels"),
            channel: pageId("Project.Channel", "Channel"),
            channelNew: pageId("Project.ChannelNew", "New Channels"),
            triggers: pageId("Project.Triggers", "Triggers"),
            deploymentTargetTrigger: pageId("Project.DeploymentTargetTrigger", "Deployment Target Trigger"),
            deploymentTargetTriggerNew: pageId("Project.DeploymentTargetTriggerNew", "New Deployment Target Trigger"),
            scheduledTrigger: pageId("Project.ScheduledTrigger", "Scheduled Trigger"),
            scheduledTriggerNew: pageId("Project.ScheduledTriggerNew", "New Scheduled Trigger"),
            variables: {
                root: pageId("Project.Variables", "Variables"),
                projectTemplates: pageId("Project.VariableTemplates", "Variable Templates"),
                commonTemplates: pageId("Project.VariableCommonTemplates", "Common Variable Templates"),
                library: pageId("Project.VariableLibrary", "Variables Library"),
                preview: pageId("Project.VariablePreview", "Variables Preview"),
                all: pageId("Project.VariableAll", "All Variables"),
            },
            process: {
                root: pageId("Project.Process", "Deployment Process"),
                stepTemplates: pageId("Project.ProcessStepTemplates", "Deployment Process Step Templates"),
                childStepTemplates: pageId("Project.ProcessChildStepTemplates", "Deployment Process Child Step Templates"),
                stepNew: pageId("Project.ProcessStepNew", "New Deployment Process Step"),
                step: pageId("Project.ProcessStep", "Deployment Process Step"),
            },
            childStepTemplates: pageId("Project.ChildStepTemplates", "Child Step Templates"),
            steptemplates: pageId("Project.StepTemplates", "Step Templates"),
            operations: {
                root: pageId("Project.Operations", "Operations"),
                runbooks: pageId("Project.Operations.Runbooks", "Runbooks"),
                triggers: pageId("Project.Operations.Triggers", "Runbook Triggers"),
                scheduledTrigger: pageId("Project.Operations.Triggers.ScheduledTrigger", "Runbook Scheduled Trigger"),
                scheduledTriggerNew: pageId("Project.Operations.Triggers.ScheduledTriggerNew", "New Runbook Scheduled Trigger"),
            },
            runbook: {
                root: pageId("Project.Runbook.Overview", "Runbook Overview"),
                runsList: pageId("Project.Runbook.RunsList", "Runbook Runs List"),
                process: {
                    root: pageId("Project.Runbook.Process", "Runbook Process"),
                    stepTemplates: pageId("Project.Runbook.ProcessStepTemplates", "Runbook Process Step Templates"),
                    childStepTemplates: pageId("Project.Runbook.ProcessChildStepTemplates", "Runbook Process Child Step Templates"),
                    stepNew: pageId("Project.Runbook.ProcessStepNew", "New Runbook Process Step"),
                    step: pageId("Project.Runbook.ProcessStep", "Runbook Process Step"),
                },
                runNow: pageId("Project.Runbook.Run", "Runbook Run"),
                settings: pageId("Project.Runbook.Settings", "Runbook Settings"),
                ...runbookSnapshotPageIds(),
                triggers: pageId("Project.Runbook.Triggers", "Runbook Triggers"),
                scheduledTrigger: pageId("Project.Runbook.ScheduledTrigger", "Runbook Scheduled Trigger"),
                scheduledTriggerNew: pageId("Project.Runbook.ScheduledTriggerNew", "New Runbook Scheduled Trigger"),
            },
        };
    },
});
